import debounce from 'debounce'
import ScrollHeader from '../modules/onScrollEffects/ScrollHeader'
import ParalaxCta from '../modules/onScrollEffects/ParalaxCta'
import MenuActive from '../modules/onScrollEffects/MenuActive'

export default ( ) => {
  let currentScrollHeight = 0
  let previousScrollHeight = 0
  
  MenuActive ( currentScrollHeight )

  window.onscroll = debounce ( ( ) => {
    currentScrollHeight = document.body.scrollTop || document.documentElement.scrollTop
    ScrollHeader ( currentScrollHeight, previousScrollHeight )
    ParalaxCta ( )
    MenuActive ( currentScrollHeight )
    previousScrollHeight = currentScrollHeight
  }, 1 )
} 


// WEBPACK FOOTER //
// ./src/js/modules/Onscroll.js